import React, { useState, useContext, createContext } from 'react'
import { prepareApiRequest, withResponseHandling } from './utils'
import PropTypes from 'prop-types'

const createSchNetApiClient = ({ apiUrl, apiToken }) => {
  return {    
    fetchCountries: async () => {
      const { url, headers } = prepareApiRequest({
        apiUrl,
        endpoint: '/api/v2/programs/countries',
      })

      const res = await fetch(url, {
        headers
      })

      return withResponseHandling(res)
    },

    fetchPrograms: async (countryCode, organisationId) => {
      let query = []

      if (countryCode) {
        query.push('country_code=' + countryCode)
      }
      if (organisationId) {
        query.push('organisation_id=' + organisationId)
      }

      const { url, headers } = prepareApiRequest({
        apiUrl,
        endpoint: `/api/v2/programs?${query.join('&')}`,
      })
      const res = await fetch(url, {
        headers
      })

      return withResponseHandling(res)
    }
  }
}

const SchNetApiContext = createContext({})

const SchNetApiContextProvider = ({ client: initialClient, children }) => {
  const [client, setClient] = useState(initialClient)
  return (
    <SchNetApiContext.Provider value={{ client, setClient }}>
      {children}
    </SchNetApiContext.Provider>
  )
}

SchNetApiContextProvider.propTypes = {
  client: PropTypes.object,
  children: PropTypes.any
}

const useSchNetApiClient = () => {
  const { client } = useContext(SchNetApiContext)

  if (!client) {
    throw new Error(`Missing Schueleraustausch.net API client, did you forget to wrap your components in SchNetApiContextProvider?`)
  }

  return client
}

export {
  SchNetApiContext,
  SchNetApiContextProvider,
  useSchNetApiClient,
  createSchNetApiClient,
}
